import * as gigTypes from 'types/consolidationDetail/gig'

export function deserializeGigs(gigs: gigTypes.GigApiResponse[]): gigTypes.Gig[] {
  if (!gigs) {
    return []
  }

  const consolGigs: gigTypes.Gig[] = []
  for (const g of gigs) {
    consolGigs.push({
      id: g.id,
      title: g.title,
      description: g.description,
      items: deserializeItems(g.items),
      images: deserializeImages(g.images),
      SupportId: g.support_id,
      estimatedSize: deserializeEstimatedSize(g.estimated_size),
      extraCompensationAmount: g.extra_compensation_amount || 0,
      extraCompensationReason: g.extra_compensation_reason || '',
      size: g.size,
      sender: deserializeSender(g.sender),
      deliveryCertifications: g.delivery_certifications,
      payoutBreakdown: deserializePayoutBreakdown(g.payout_breakdown),
      pendingExpenses: g.pending_expenses,
      deliveryOptions: g.delivery_options,
      pickupWindow: g.pickup_window || { start: null, end: null },
      verifiedAvatarUrl: g.verified_avatar_url,
    })
  }

  return consolGigs
}

function deserializeItems(items: gigTypes.ItemApiResponse[]): gigTypes.Item[] {
  if (!items) {
    return []
  }

  const gItems: gigTypes.Item[] = []
  for (const i of items) {
    gItems.push({
      id: i.id,
      referenceId: i.reference_id || '',
      description: i.description || '',
      value: i.value || 0,
      length: i.length,
      width: i.width,
      height: i.height,
      weight: i.weight,
      quantity: i.quantity,
      pickedUpQuantity: i.picked_up_quantity,
    })
  }

  return gItems
}

function deserializeImages(images: gigTypes.ImageApiResponse[]): gigTypes.Image[] {
  if (!images) {
    return []
  }

  const gImages: gigTypes.Image[] = []
  for (const i of images) {
    gImages.push({
      url: i.url,
      imageType: i.image_type,
    })
  }

  return gImages
}

function deserializeEstimatedSize(size: gigTypes.EstimatedSizeApiResponse | undefined): gigTypes.EstimatedSize {
  return {
    weightLb: size?.weight_lb || 0,
    weightKg: size?.weight_kg || 0,
    volumeCubicIn: size?.volume_cubic_in || 0,
    volumeCubicCm: size?.volume_cubic_cm || 0,
    maxDimIn: size?.max_dim_in || 0,
    maxDimCm: size?.max_dim_cm || 0,
    secondMaxDimIn: size?.second_max_dim_in || 0,
    secondMaxDimCm: size?.second_max_dim_cm || 0,
    updatedAt: size?.updated_at || '',
  }
}

function deserializeSender(sender: gigTypes.SenderApiResponse): gigTypes.Sender {
  return {
    name: sender.name,
    avatarUrl: sender.avatar_url,
    verifiedAvatarUrl: sender.verified_avatar_url,
    averageRating: sender.average_rating,
    ratingCount: sender.rating_count,
    bio: sender.bio,
    settings: {
      latestDeliveryTime: sender.settings?.latest_delivery_time,
    },
  }
}

function deserializePayoutBreakdown(breakdown: gigTypes.PayoutBreakdownApiResponse): gigTypes.PayoutBreakdown {
  return {
    netTip: breakdown.net_tip,
    tollAdjustment: breakdown.toll_adjustment,
    expenseAdjustment: breakdown.expense_adjustment,
    incidentals: breakdown.incidentals,
    instantPayFee: breakdown.instant_pay_fee,
  }
}
